import React, { useCallback, useEffect, useLayoutEffect, useMemo } from 'react';
import { Button } from 'design-system/Button';
import { ButtonGroup } from 'design-system/ButtonGroup';
import useColors from 'hooks/useColors';
import { Avatar } from 'design-system/avatar';
import { SpaceInviteAction } from 'design-system/SpaceInviteAction';
import EmptyComponent from 'design-system/EmptyComponent';
import { useSpaceInvite } from './hooks';
const SpaceInvite = ({ route, navigation, }) => {
    const colors = useColors();
    const { spaceId, inviteId, fromHeader } = route.params;
    const { spaceInvite, fetching, acceptInvite, rejectInvite } = useSpaceInvite(inviteId, spaceId);
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Space Invite',
            headerShown: false,
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, [colors.text.primary, colors.text.white]);
    const { firstName, lastName, imageUrl, title, message, buttonText, isPending, } = useMemo(() => {
        let firstName = '';
        let lastName;
        let imageUrl;
        let title = 'Someone invited you to join a space';
        let buttonText = 'Join space';
        let isPending = true;
        const message = 'Money’s better when managed together.';
        if (spaceInvite && spaceInvite.space && spaceInvite.userInviting) {
            const { space, userInviting: spaceOwner } = spaceInvite;
            const { name: spaceName } = space;
            if (spaceOwner && spaceOwner.firstName) {
                ({ firstName, lastName, imageUrl } = spaceOwner);
                title = `${firstName} invited you to join a space named "${spaceName}"`;
                buttonText = `Join the space`;
            }
            isPending = spaceInvite.isPending;
        }
        return {
            firstName,
            lastName,
            imageUrl,
            title,
            message,
            buttonText,
            isPending,
        };
    }, [spaceInvite]);
    const onRejected = useCallback(() => rejectInvite(inviteId), [inviteId, rejectInvite]);
    const onAccepted = useCallback(() => acceptInvite(inviteId), [acceptInvite, inviteId]);
    useEffect(() => {
        if (!isPending) {
            navigation.pop();
            if (fromHeader)
                navigation.navigateDeprecated('MySpaces');
        }
    }, [isPending, fromHeader, navigation]);
    if (!isPending)
        return null;
    return (<SpaceInviteAction title={title} subTitle={message} icon={<Avatar name={firstName} lastName={lastName} size={54} color={colors.background.brandLight} borderWidth={1} fontColor={colors.text.textOnBrand} imageUrl={imageUrl}/>}>
      <ButtonGroup type="floating">
        <Button brandReversed onPress={onRejected} title="Reject" isFetching={fetching}/>
        <Button brand onPress={onAccepted} title={buttonText} isFetching={fetching}/>
      </ButtonGroup>
    </SpaceInviteAction>);
};
export default SpaceInvite;
